// extracted by mini-css-extract-plugin
var _1 = "CancelSubscriptionConfirmation_buttonsContainer__Z8yTP";
var _2 = "CancelSubscriptionConfirmation_container__3eNin";
var _3 = "CancelSubscriptionConfirmation_info__lcCEW";
var _4 = "CancelSubscriptionConfirmation_title__qrQEg";
export { _1 as "buttonsContainer", _2 as "container", _3 as "info", _4 as "title" }
